var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-3"},[(_vm.series[0].data && _vm.series[0].data.length != 0)?_c('VueApexCharts',{attrs:{"height":"420px","type":"line","options":_vm.options,"series":_vm.series}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }